import { memo } from 'react';

import MembersSuspendFlow from './MembersSuspendFlow';

/**
 * Two-step bulk Suspend (soft delete) for the selected members, as in the prototype: step 1 lists
 * who is included, step 2 asks to type the confirmation word. The per-person flow with its
 * "what they lose" summary lives in the member detail (CT-5574).
 *
 * @param {object} props
 * @param {{ id: string, displayName: string, email: string }[]} props.members Members about to be suspended (empty: closed).
 * @param {boolean} [props.isBusy] Suspending: Back, the way out and the red button are locked.
 * @param {() => void} props.onConfirm
 * @param {() => void} props.onCancel
 */
const MembersSuspendModal = ({ members, isBusy = false, onConfirm, onCancel }) =>
  members.length ? (
    <MembersSuspendFlow members={members} isBusy={isBusy} onConfirm={onConfirm} onCancel={onCancel} />
  ) : null;

export default memo(MembersSuspendModal);
